export default __webpack_public_path__ + "static/media/ouestfrance.1bc6f0c5.png";